import Controller from '@ember/controller';
import { inject as service } from '@ember/service';
import BillingService from 'cio/services/billing';

export default class BillingHistoryController extends Controller {
  @service billing!: BillingService;

  get subscription() {
    return this.billing.subscription ?? null;
  }
}

declare module '@ember/controller' {
  interface Registry {
    'billing.billing-history': BillingHistoryController;
  }
}
